import { render } from "./GelijkTijd.vue?vue&type=template&id=d4ef6b56&scoped=true"
import script from "./GelijkTijd.vue?vue&type=script&lang=js"
export * from "./GelijkTijd.vue?vue&type=script&lang=js"

import "./GelijkTijd.vue?vue&type=style&index=0&id=d4ef6b56&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ef6b56"]])

export default __exports__